import { Component } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'anon-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.scss']
})
export class UserHeaderComponent {

  constructor(
    public authService: AuthService,
    public menuService: MenuService
  ) { }
}
